import { render, staticRenderFns } from "./Anxunheader.vue?vue&type=template&id=876a3206&scoped=true"
import script from "./Anxunheader.vue?vue&type=script&lang=js"
export * from "./Anxunheader.vue?vue&type=script&lang=js"
import style0 from "./Anxunheader.vue?vue&type=style&index=0&id=876a3206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876a3206",
  null
  
)

export default component.exports